export default "<div class=\"theme\">\n  {{ThemeInComponent?.Nom}}\n</div>";